import {BaseIdCodeModel} from 'common-shared';

export class ClassificatorValueModel extends BaseIdCodeModel {
  Value: string;
  Comment: string;
  Data: string;
  ClassificatorId: string;
  IsDefault?: boolean;
  IsDisabled?: boolean;
  Sequence?: number;

  constructor(init?: Partial<ClassificatorValueModel>) {
    super();
    Object.assign(this, init);
  }

  static Create(init?: Partial<ClassificatorValueModel>) {
    return Object.assign(new ClassificatorValueModel({
      IsDefault: false
    }), init);
  }

  isEmpty(): boolean {
    return Object.keys(this).filter(key => key !== 'Id').every(key => !this[key]);
  }
}
